import { Button } from "@chakra-ui/react";
import React from "react";
import { useTranslation } from "react-i18next";
import { useHelpButtonOnClick } from "shared/hooks/useHelpButtonOnClick";

export interface AuthHelpButtonProps {
  onClick?: () => void;
}

export const AuthHelpButton: React.FC<
  React.PropsWithChildren<AuthHelpButtonProps>
> = ({ onClick: onClickProp, children }) => {
  const { t } = useTranslation(["common"]);
  const onClickDefault = useHelpButtonOnClick();
  const onClick = onClickProp ?? onClickDefault;
  return (
    <Button variant="subtle" ml="-4px" onClick={onClick}>
      {children ?? t("common:help")}
    </Button>
  );
};
